const TUTORIAL_COOKIES = {
    LATEST: "seen_tutorial_v_1_5"
    };
    
export { TUTORIAL_COOKIES };